/* eslint-disable @typescript-eslint/no-magic-numbers */
import { isDevEnv } from "@buildwithflux/shared";
import { get, set } from "./inMemoryCache";
import { serializeToBuilder, StreamingKeyBuilder } from "./keySerializer";
// We don't want keys this large because of memory consumption.
const MAX_KEY_LENGTH = 100 * 1000;
export function createKey(dependencies, cacheKeyPrefix) {
    const builder = new StreamingKeyBuilder(cacheKeyPrefix, MAX_KEY_LENGTH);
    for (let i = 0; i < dependencies.length; i++) {
        if (i > 0)
            builder.append(",");
        serializeToBuilder(builder, dependencies[i]);
    }
    const key = builder.build();
    if (builder.wasHashed() && isDevEnv()) {
        // eslint-disable-next-line no-console
        console.warn(`[useCache] Dependency array for ${cacheKeyPrefix} results in key that exceeds the recommended max length. We will hash the key to safe memory but it would be better if you try to create a more efficient dependency array!`);
    }
    return key;
}
export function cacheHelper(key, factory) {
    let result = get(key);
    if (!result) {
        result = factory();
        if (result !== undefined && result !== null) {
            set(key, result);
        }
    }
    return result;
}
export function cache(factory, cacheKeyPrefix, dependencies) {
    const key = createKey(dependencies, cacheKeyPrefix);
    return cacheHelper(key, factory);
}
//# sourceMappingURL=cache.js.map